import React from 'react';
import { useNavigate } from 'react-router-dom';
import PageBackground from '../components/PageBackgroundBeam';
import './Welcome.css';
import logo from '../assets/logo-publisearch.png';

function Welcome() {
  const navigate = useNavigate();

  return (
    <PageBackground>
      <div className="welcome">
        <div className="welcome-content">
          <div className="logo-container">
            <img src={logo} alt="Publisearch" className="logo" />
          </div>

          <div className="title-block">
            <h1 className="title">
              <span className="title-line1">Panorama 2025</span>
              <span className="title-amp">&</span>
              <span className="title-line2">Tendencias 2026</span>
            </h1>

            <div className="divider">
              <span className="divider-line"></span>
              <span className="divider-diamond"></span>
              <span className="divider-line"></span>
            </div>

            <p className="subtitle">
              Por <strong>Ricardo Martinez</strong>
            </p>
            <p className="role">
              CEO Publisearch-AdvanceTMS
            </p>
          </div>

          <div className="country-badge">
            <span className="badge-flag">HN</span>
            <span className="badge-text">Honduras</span>
          </div>

          <button className="btn-start" onClick={() => navigate('/top25-anunciantes')}>
            Comenzar
            <span className="btn-arrow">&#8594;</span>
          </button>
        </div>
      </div>
    </PageBackground>
  );
}

export default Welcome;
